module.exports = __webpack_public_path__ + "img/2_191.9c7bf396.png";